/* eslint-disable no-unused-vars */
import * as React from "react";
/* eslint-enable no-unused-vars */
import { connect } from "react-redux";
import { IApplicationState } from "../../models/store/storeTypes";
import * as storeActions from "../../models/store/storeActions";
import * as storeEffects from "../../models/store/storeEffects";
import { Base } from "ui/Scripts/source/framework/base";
import { IFrontPageStateProps, IFrontPageOwnProps, IFrontPageDispatchProps, FrontPage } from "../../components/front/frontPage";

export function mapStateToProps(applicationState: IApplicationState, ownProps: IFrontPageOwnProps): IFrontPageStateProps {
    if (Base.isNullOrUndefined(applicationState) || Base.isNullOrUndefined(applicationState.event) || Base.isNullOrUndefined(applicationState.event.eventList)) {
        return {
            user: null,
            state: null
        };
    }
    return {
        user: applicationState.user,
        state: applicationState.front
    };
}

export function mapDispatchToProps(dispatch: storeEffects.FrontThunkDispatch): IFrontPageDispatchProps {
    return {
        loadFrontPage: () => dispatch(storeEffects.getFrontPage()),
        loadFrontPageMessage: () => dispatch(storeEffects.getFrontPageMessage()),
        loadFrontPageEvent: () => dispatch(storeEffects.getFrontPageEvent()),
        loadFrontPageTask: () => dispatch(storeEffects.getFrontPageTask()),
        loadFrontPageDocument: () => dispatch(storeEffects.getFrontPageDocument()),
        loadFrontPageInstantMessage: () => dispatch(storeEffects.getFrontPageInstantMessage()),
        loadFrontPageCalendarTask: () => dispatch(storeEffects.getFrontPageCalendarTask()),
        
        setLastOpenedMessageId: (id: string) => dispatch(storeActions.messageListSetLastOpened(id)),
        setLastOpenedEventId: (id: string) => dispatch(storeActions.eventListSetLastOpened(id)),
        setLastOpenedTaskId: (id: string) => dispatch(storeActions.taskListSetLastOpened(id)),
        setLastOpenedDocumentId: (id: string) => dispatch(storeActions.documentListSetLastOpened(id)),
        setLastOpenedInstantMessageChannelId: (id: string) => dispatch(storeActions.instantMessageChannelListSetLastOpened(id)),
        setLastOpenedCalendarTaskId: (id: string) => dispatch(storeActions.calendarTaskViewSetLastOpened(id)),

        setMessageEditReturnUrl: (url: string) => dispatch(storeActions.messageEditSetReturnUrl(url)),
        setEventEditReturnUrl: (url: string) => dispatch(storeActions.eventEditSetReturnUrl(url)),
        setTaskEditReturnUrl: (url: string) => dispatch(storeActions.taskEditSetReturnUrl(url)),
        setInstantMessageChannelOpenSetReturnUrl: (url: string) => dispatch(storeActions.instantMessageChannelOpenSetReturnUrl(url)),
        setCalendarTaskEditReturnUrl: (url: string) => dispatch(storeActions.calendarTaskEditSetReturnUrl(url)),

        onLogout: () => dispatch(storeEffects.logout())
    };
}

export default connect<IFrontPageStateProps, IFrontPageDispatchProps, IFrontPageOwnProps>(mapStateToProps, mapDispatchToProps)(FrontPage);